import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import Heading from '../components/Heading'
import ModuleWithLoader from '../components/ModuleWithLoader'
import DataSource from '../DataSource'
import CustomLink from '../components/CustomLink'
import FormSuccess from '../components/FormSuccess'
import AjaxLoaderImg from '../components/AjaxLoaderImg'
import Button from '../elements/Button'
import ReactModal from './ReactModal'
import LoadingOverlay from '../components/LoadingOverlay'

const CancelTelstraService = (props) => {
    const [isLoading, setIsLoading] = useState(false)
    const [isCancelled, setIsCancelled] = useState(false)
    const [hasError, setHasError] = useState(false)
    const [showModal, setShowModal] = useState(false)

    const handleCancel = (event) => {
        event.preventDefault()
        setShowModal(false)
    }

    const handleShowModal = (event) => {
        event.preventDefault()
        setShowModal(true)
    }

    const handleSubmit = (event) => {
        event.preventDefault()
        setShowModal(false)
        cancelService()
    }

    const cancelService = event => {
        setIsLoading(true)
        setHasError(false)
        DataSource.postData('/api/postCancelService/mobile', { serviceId: props.serviceId }, response => {
            setIsLoading(false)
            setIsCancelled(true)
        }, () => {
            setIsLoading(false)
            setHasError(true)
        })
    }

    return (
        <div className='cancel-telstra-service module'>
            <Heading title='Cancel my service' />
            <ModuleWithLoader isLoaded className='p-4'>
                <LoadingOverlay isLoading={isLoading}>
                    <div className='row mb-4'>
                        <div className='col-12 col-md-10 offset-md-1 text-center'>
                            <p className='m-0 lh'>You can cancel your ExeSIM pre-paid mobile service here. You will be able to use your purchased allowances or any Add-ons you have purchased until your plan’s recharge cycle expires. Please refer to the My Usage tab for your account status. You also have 180 days to re-activate your account and keep your number, or port your mobile number to another mobile provider.</p>
                        </div>
                    </div>
                    {isCancelled ? <FormSuccess message='Your ExeSIM pre-paid service has been cancelled. You have 180 days to re-activate your account and keep your number, or port your mobile number to another mobile provider.' /> : ''}
                    {!isCancelled
                        ? <div className='row'>
                            <div className='col-12 text-center'>
                                <Button
                                    title='Cancel my service'
                                    action={handleShowModal}
                                    color='red'
                                />
                            </div>
                          </div>
                        : ''}
                    {hasError ? <div className='row-error w-100 mt-3'>Oops! Something went wrong with your request. Please try again above, if the issue persists give us a call on 13 39 38.</div> : ''}
                </LoadingOverlay>
            </ModuleWithLoader>

            <ReactModal showModal={showModal} handleCloseModal={() => setShowModal(false)} heading='Just checking'>
                <div className='row'>
                    <div className='col-12 text-center'>
                        <p className='mt-0 mb-4 lh'>Please confirm you would like to cancel your mobile service?</p>
                        <div className='d-flex justify-content-center'>
                            <Button title='Confirm' action={handleSubmit} className='mr-3' />
                            <Button title='Cancel' action={handleCancel} color='red' />
                        </div>
                    </div>
                    {props.children}
                </div>
            </ReactModal>
        </div>
    )
}

CancelTelstraService.propTypes = {
    serviceId: PropTypes.number.isRequired
}

export default CancelTelstraService



// WEBPACK FOOTER //
// ./resources/js/modules/CancelTelstraService.js